import { activateI18n } from '@retail/funnel-components';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/nl-be/messages';
import { messages as retailMessages } from '../translations/autohero-common/nl-be/messages';

activateI18n('nl-BE', {
  ...retailMessages,
  ...sellOnlyMessages,
});
